import { render } from "./EditSimple.vue?vue&type=template&id=22b51837&scoped=true"
import script from "./EditSimple.vue?vue&type=script&lang=js"
export * from "./EditSimple.vue?vue&type=script&lang=js"

import "./EditSimple.vue?vue&type=style&index=0&id=22b51837&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b51837"]])

export default __exports__